import React from 'react';
import { useSelector } from 'react-redux';

import { getState } from 'features/order-tracker/store/selectors';
import { AQA_ELEMENTS_MARKER_LIST } from 'features/order-tracker/utils/aqaElementsIDList';

import styles from './style.module.scss';

export const OrderNumber: React.FC = () => {
  const {
    orderSummary: {
      orderReference,
    },
  } = useSelector(getState);

  return (
    <div className={styles.numberContainer}>
      <p className={styles.numberText}>Order number:</p>
      <p id={AQA_ELEMENTS_MARKER_LIST.summaryPage.orderSummary.orderNumber}>{orderReference}</p>
    </div>
  );
};
